import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { useLanguage } from '../hooks/useLanguage';
export function PrivacyPolicyPage() {
  const {
    language
  } = useLanguage();
  const isRTL = language === 'ar';
  return <div className="min-h-screen bg-gray-50" dir={isRTL ? 'rtl' : 'ltr'} data-id="element-2820">
      <Navbar data-id="element-2821" />

      <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-2822">
        <Link to="/" className="inline-flex items-center gap-2 text-[#4f1964] hover:text-[#3d1350] mb-8 transition-colors" data-id="element-2823">
          <ArrowLeft className={`w-4 h-4 ${isRTL ? 'rotate-180' : ''}`} data-id="element-2824" />
          <span data-id="element-2825">{isRTL ? 'العودة للرئيسية' : 'Back to Home'}</span>
        </Link>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-2826">
          <div className="flex items-center gap-4 mb-8" data-id="element-2827">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-2828">
              <Shield className="w-8 h-8 text-[#4f1964]" data-id="element-2829" />
            </div>
            <div data-id="element-2830">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-2831">
                {isRTL ? 'سياسة الخصوصية' : 'Privacy Policy'}
              </h1>
              <p className="text-gray-500 mt-1" data-id="element-2832">
                {isRTL ? 'آخر تحديث: يناير 2025' : 'Last updated: January 2025'}
              </p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-2833">
            {isRTL ? <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2834">
                  مقدمة
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2835">
                  في Operines، نحن ملتزمون بحماية خصوصيتك وأمان بياناتك. توضح
                  سياسة الخصوصية هذه كيفية جمع واستخدام وحماية معلوماتك الشخصية
                  عند استخدام منصتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2836">
                  المعلومات التي نجمعها
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2837">
                  نقوم بجمع الأنواع التالية من المعلومات:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2838">
                  <li data-id="element-2839">معلومات الحساب: الاسم، البريد الإلكتروني، رقم الهاتف</li>
                  <li data-id="element-2840">معلومات الأعمال: اسم النشاط التجاري، الفئة، الوصف</li>
                  <li data-id="element-2841">بيانات الاستخدام: كيفية تفاعلك مع منصتنا</li>
                  <li data-id="element-2842">معلومات تقنية: عنوان IP، نوع المتصفح، نظام التشغيل</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2843">
                  كيف نستخدم معلوماتك
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2844">
                  نستخدم معلوماتك من أجل:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2845">
                  <li data-id="element-2846">تقديم وتحسين خدماتنا</li>
                  <li data-id="element-2847">التواصل معك بشأن حسابك والتحديثات</li>
                  <li data-id="element-2848">معالجة المعاملات والفواتير</li>
                  <li data-id="element-2849">تخصيص تجربتك</li>
                  <li data-id="element-2850">ضمان أمان المنصة ومنع الاحتيال</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2851">
                  مشاركة البيانات
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2852">
                  نحن لا نبيع معلوماتك الشخصية. قد نشارك بياناتك مع مزودي خدمات
                  موثوقين يساعدوننا في تشغيل منصتنا، مثل خدمات الاستضافة ومعالجة
                  الدفع، وذلك فقط بالقدر اللازم لتقديم خدماتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2853">
                  أمان البيانات
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2854">
                  نستخدم تدابير أمنية متقدمة لحماية معلوماتك، بما في ذلك التشفير
                  والتخزين الآمن وضوابط الوصول. ومع ذلك، لا يمكن لأي طريقة نقل
                  عبر الإنترنت أن تكون آمنة بنسبة 100%.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2855">
                  حقوقك
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2856">
                  لديك الحق في:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2857">
                  <li data-id="element-2858">الوصول إلى بياناتك الشخصية</li>
                  <li data-id="element-2859">تصحيح المعلومات غير الدقيقة</li>
                  <li data-id="element-2860">طلب حذف بياناتك</li>
                  <li data-id="element-2861">الاعتراض على معالجة بياناتك</li>
                  <li data-id="element-2862">طلب نقل البيانات</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2863">
                  الاتصال بنا
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2864">
                  إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال
                  بنا على:
                  <br data-id="element-2865" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-2866">
                    hello@operines.ai
                  </a>
                </p>
              </> : <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2867">
                  Introduction
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2868">
                  At Operines, we are committed to protecting your privacy and
                  securing your data. This Privacy Policy explains how we
                  collect, use, and safeguard your personal information when you
                  use our platform.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2869">
                  Information We Collect
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2870">
                  We collect the following types of information:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2871">
                  <li data-id="element-2872">Account Information: Name, email, phone number</li>
                  <li data-id="element-2873">
                    Business Information: Business name, category, description
                  </li>
                  <li data-id="element-2874">Usage Data: How you interact with our platform</li>
                  <li data-id="element-2875">
                    Technical Information: IP address, browser type, operating
                    system
                  </li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2876">
                  How We Use Your Information
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2877">
                  We use your information to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2878">
                  <li data-id="element-2879">Provide and improve our services</li>
                  <li data-id="element-2880">Communicate with you about your account and updates</li>
                  <li data-id="element-2881">Process transactions and billing</li>
                  <li data-id="element-2882">Personalize your experience</li>
                  <li data-id="element-2883">Ensure platform security and prevent fraud</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2884">
                  Data Sharing
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2885">
                  We do not sell your personal information. We may share your
                  data with trusted service providers who help us operate our
                  platform, such as hosting and payment processing services,
                  only to the extent necessary to provide our services.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2886">
                  Data Security
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2887">
                  We use industry-standard security measures to protect your
                  information, including encryption, secure storage, and access
                  controls. However, no method of transmission over the internet
                  can be 100% secure.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2888">
                  Your Rights
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2889">
                  You have the right to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2890">
                  <li data-id="element-2891">Access your personal data</li>
                  <li data-id="element-2892">Correct inaccurate information</li>
                  <li data-id="element-2893">Request deletion of your data</li>
                  <li data-id="element-2894">Object to data processing</li>
                  <li data-id="element-2895">Request data portability</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2896">
                  Contact Us
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2897">
                  If you have any questions about this Privacy Policy, please
                  contact us at:
                  <br data-id="element-2898" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-2899">
                    hello@operines.ai
                  </a>
                </p>
              </>}
          </div>
        </motion.div>
      </div>
    </div>;
}